document.addEventListener("DOMContentLoaded", function() {
    $('.carousel-slide-container').slick({
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3500
    });
	
	// Remove from Product.cshtml and uncomment this //

    var $carousel = $('.slider-for');
    $carousel.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		adaptiveHeight: true,
		asNavFor: '.slider-nav'
	}).magnificPopup({
		type: 'image',
		delegate: 'a:not(.slick-cloned)',
		closeOnContentClick: false,
		tLoading: 'Loading...',
		mainClass: 'mfp-zoom-in mfp-img-mobile',
		image: {
			verticalFit: true,
			tError: '<a href="%url%">Image #%curr%</a> failed to load.'
		},
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			tCounter: '<span class="mfp-counter">%curr% of %total%</span>',
			preload: [0, 1]
		},
		zoom: {
			enabled: true,
			duration: 300
		},
		removalDelay: 300,
		callbacks: {
			open: function () {
				$.magnificPopup.instance.next = function () {
					var self = this;
					self.wrap.removeClass('mfp-image-loaded');
					setTimeout(function () {
						$.magnificPopup.proto.next.call(self);
					}, 120);
				};
				$.magnificPopup.instance.prev = function () {
					var self = this;
					self.wrap.removeClass('mfp-image-loaded');
					setTimeout(function () {
						$.magnificPopup.proto.prev.call(self);
					}, 120);
				};
				var current = $carousel.slick('slickCurrentSlide');
				$carousel.magnificPopup('goTo', current);
			},
			imageLoadComplete: function () {
				var self = this;
				setTimeout(function () {
					self.wrap.addClass('mfp-image-loaded');
				}, 16);
			},
			beforeClose: function () {
				$carousel.slick('slickGoTo', parseInt(this.index));
			}
		}
	});

	$('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        variableWidth: true
    });

	$('.product-logos').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 1
            }
        }]
    });
	
	$('.js-similar-case-studies').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
        }]
    });
});

$(".slider-nav, .product-logos, .carousel-slide-container").on("init", function(event, slick) {
	if (!$(this).find(".slick-prev").length && !$(this).find(".slick-next").length) {
	  	$(this).find(".slick-track").addClass("no-slide");
	}
});

$(".js-similar-case-studies").on("init", function(event, slick) {
	if (!$(this).find(".slick-prev").length && !$(this).find(".slick-next").length) {
	  	$(this).find(".slick-track").addClass("no-slide");
	  	$(".cs-related-container").addClass("no-slide");
	}
});

$(".slider-nav, .product-logos, .carousel-slide-container, .js-similar-case-studies").on('afterChange', function(event, slick, currentSlide, nextSlide){
	setTimeout(function() {
		$(window).trigger('resize').trigger('scroll');
	}, 500);
});